export default __webpack_public_path__ + "static/media/faustin_river.90414179.jpg";